// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxMenuItem_checkbox__e+ANe","icon":"CheckboxMenuItem_icon__ShW6u"};